import createReducer from '../utils/createReducer';
import DynamicLayoutActions from '../actions/dynamicLayoutActions';

/*
    This reducer is currently not tested due to lack of functionality.
*/
const initialState = null;

const actionHandlers = {
    [DynamicLayoutActions.UPDATE_DYNAMIC_LAYOUT](state, {payload}) {
        const {dynamicLayout} = payload;

        if (dynamicLayout === null) {
            return null;
        }

        return {
            ...state,
            ...dynamicLayout
        };
    }
};

export default createReducer(actionHandlers, initialState);
